module.exports = __webpack_public_path__ + "img/genomes.22c3ac35.png";